const usLangOrder = {
  'list-orders-all.helmet': 'All orders',
  'list-orders-all.breadcrumb.title': 'List of orders',
  'list-orders-all.breadcrumb.parent': 'Order management',
  'list-orders-all.col.date': 'Date of application',
  'list-orders-all.col.code': 'Code orders',
  'list-orders-all.col.customer': 'Client',
  'list-orders-all.col.products': 'Product',
  'list-orders-all.col.products.code': 'Sp',
  'list-orders-all.col.products.barcode': 'Barcode',
  'list-orders-all.col.products.name': 'SP name',
  'list-orders-all.col.products.number': 'Quantity',
  'list-orders-all.col.payment': 'Pay',
  'list-orders-all.col.payment.cash': 'Cash',
  'list-orders-all.col.payment.bank': 'Transfer',
  'list-orders-all.modal.detail.title.customer': 'Customer information',
  'list-orders-all.modal.detail.title.order': 'Information line',
  'list-orders-all.modal.name.label': 'Customer name',
  'list-orders-all.modal.phone.label': 'Phone number',
  'list-orders-all.modal.address.label': 'Address',
  'list-orders-all.modal.order-code.label': 'Single code',
  'list-orders-all.modal.order-status.label': 'Payments',
  'list-orders-all.modal.created.label': 'Date of application',
  'list-orders-all.modal.note.label': 'Note of order',
  'list-orders-all.modal.items.label': 'List of products',
  'list-orders-all.modal.items.stt.col': 'stt',
  'list-orders-all.modal.items.info.col': 'Product information',
  'list-orders-all.modal.items.name.col': 'SP name',
  'list-orders-all.modal.items.code.col': 'Sp',
  'list-orders-all.modal.items.barcode.col': 'Barcode',
  'list-orders-all.modal.items.unit.col': 'Unit',
  'list-orders-all.modal.items.source.col': 'Origin',
  'list-orders-all.modal.items.desc.col': 'Note',
  'list-orders-all.modal.items.number.col': 'Quantity',
  'list-orders-all.modal.items.number.quantity.col': 'Put',
  'list-orders-all.modal.items.number.return.col': 'Pay',
  'list-orders-all.modal.items.price.col': 'Unit price',
  'list-orders-all.modal.items.discount.col': 'Discount',
  'list-orders-all.modal.items.total.col': 'Into money',
  'list-orders-all.modal.discount.label': 'Discount',
  'list-orders-all.modal.total.label': 'Total',
  'list-orders-all.title-empty': '(No data)',
  'list-orders-all.note.copy': 'Copy successful customer information',
  'list-orders-all.btn.detail': 'Order details',
  'list-orders-all.btn.return': 'Returns',
  'list-orders-all.modal.header.detail.title': 'Details of order information',
  'list-orders-all.modal.header.return.title': 'Returns',
  'list-orders-all.note.create-order-return.success': 'Successful return!',
  'list-orders-all.note.create-order-return.failure': 'Successful return!Please try again later.',
  'list-orders-all.guest': 'Guest',
};

export default usLangOrder;
